export const promoCodeUsagesConstants = {
    GET_PROMO_CODE_USAGES_REQUEST: 'GET_PROMO_CODE_USAGES_REQUEST',
    GET_PROMO_CODE_USAGES_SUCCESS: 'GET_PROMO_CODE_USAGES_SUCCESS',
    GET_PROMO_CODE_USAGES_FAIL: 'GET_PROMO_CODE_USAGES_FAIL',
}